"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var StyledModal_1 = require("./StyledModal");
var Background = function (_a) {
    var clickAwayClose = _a.clickAwayClose, onClose = _a.onClose, children = _a.children;
    var backgroundRef = react_1.default.createRef();
    var handleBackgroundClick = function (e) {
        if (e.target === backgroundRef.current)
            onClose();
    };
    react_1.default.useEffect(function () {
        document.body.style.overflow = 'hidden';
        return function () {
            document.body.style.overflow = '';
        };
    }, []);
    return (react_1.default.createElement(StyledModal_1.ModalBackground, { onClick: clickAwayClose ? handleBackgroundClick : undefined, ref: backgroundRef, "data-testid": "modal-fade-background" }, children));
};
exports.default = Background;
//# sourceMappingURL=Background.js.map